import { render, staticRenderFns } from "./SystemModulesList.vue?vue&type=template&id=c7df0dee"
import script from "./SystemModulesList.vue?vue&type=script&lang=js"
export * from "./SystemModulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports